import React, { useEffect, useState } from 'react';
import BaseForm from 'components/atoms/base-form';
import BaseFormItem from 'components/atoms/base-form/item';
import { useFormik } from 'formik';
import PatientBlock from 'components/molecules/patientBlock';
import { useTranslation } from 'react-i18next';
import { usePatientInfo } from 'infrastructure/hooks/patient/use-patient-info';
import { useEdit } from 'infrastructure/providers/edit-provider';
import BaseInput from 'components/atoms/base-input';
import useUser from 'utils/useUser';

import s from './styles.module.scss';
import { deviceOrderSpecificationValidationSchema } from './validation-schema';

import type { Patient } from 'infrastructure/classes/patient/patient';

const formKey = 'AdminPanelPatientInfoForm';

interface Props {
  data: Patient;
  loading?: boolean;
}

const DeviceOrderSpecificationForm: React.FC<Props> = (props) => {
  const { data, loading: loadingProp = false } = props;
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const { canEdit, setEdit } = useEdit();
  const { t } = useTranslation();
  const { loading, updatePatientInfo } = usePatientInfo({
    patientGuid: data.guid,
  });
  const { iamPatientAcceptance } = useUser();

  const formik = useFormik({
    initialValues: data,
    onSubmit: async (values) => {
      await updatePatientInfo(values).then(() => {
        formik.resetForm({ values });
      });
      setIsEdit(false);
      setEdit(false);
    },
    validationSchema: deviceOrderSpecificationValidationSchema(),
    validateOnChange: false,
  });

  const onEdit = () => {
    setIsEdit(true);
    setEdit(true, formKey);
  };
  const onSave = () => {
    formik.submitForm();
  };
  const onCancel = () => {
    formik.resetForm();
    setIsEdit(false);
    setEdit(false);
  };

  useEffect(() => {
    formik.resetForm({ values: data });
  }, [data]);

  return (
    <PatientBlock
      title={t('labels.deviceOrderSpecifications')}
      isEdit={isEdit}
      onEdit={onEdit}
      onSave={onSave}
      onCancel={onCancel}
      loading={loading || loadingProp}
      disabled={!canEdit(formKey) || iamPatientAcceptance}
    >
      <div className={s.wrapper}>
        <BaseForm
          formik={formik}
          plaintext={!isEdit}
          readonly={!isEdit}
          disabled={!canEdit(formKey)}
        >
          <BaseFormItem
            name="deviceOrderSpecifications"
            label={t('labels.deviceOrderSpecifications')}
          >
            <BaseInput />
          </BaseFormItem>
        </BaseForm>
      </div>
    </PatientBlock>
  );
};

export default DeviceOrderSpecificationForm;
